import React from 'react';
import axios from "../../../containers/api";
import { showCatchError, toEnglishNumbers } from "../../../helpers/Utils";
import { Button, Card, CardBody, ModalBody, Modal, ModalHeader, Row, Badge, ModalFooter, Alert } from "reactstrap";
import {Table} from "../../../components/table/Table";
import {Colxx, Separator} from "../../../components/common/CustomBootstrap";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import NewTransportationCompany from "../../../components/admin/NewTransportationCompany";
import EditTransportationCompany from "./components/EditTransportationCompany";
import NotAllowedkalas from "./components/NotAllowedkalas";
import PersonAccountActivities from "../../../components/admin/PersonAccountActivities";
import ChargeTransportationCompany from "./components/ChargeTransportationCompany";
import AgentAccess from "./components/AgentAccess";
import AgentSalonFinancialConfig from "./components/AgentSalonFinancialConfig";
import AgentSazman from "./components/AgentSazman";
import ChangePassModal from "../../user/components/ChangePassModal";
import Config from "../../../constants/config";
class ManageTransportationCompany extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            AgentLists: [],
            errors: [],
            AddModal: false,
           // ProvinceList: [],
            EditModal: false,
            OneTransportationCompany: {},
           
            kalaModal: false,
            transportationCompanyId: null,
            ShowAccountActivityModal: false,
            AgentChargeModal: false,
            AgentSazmanModal: false,
            AgentAccessModal: false,
            showFinancialConfigSalonModal: false,
            optionsMenu: null,
            ChangePassModal: false,
            showNewMemberModal: false,
            FileUploadModal: false,
            ShowFileUploadModal: false,
        }

    }

    componentDidMount() {
         
       // this.CheckMemberTypeIsAdmin();
       this.GetAllTransportationCompany();
    }

    CheckMemberTypeIsAdmin = () => {
        this.props.showSpinner();
        axios.get('api/ClientApi/CheckMemberTypeIsAdmin')
            .then((res) => {
                this.props.hideSpinner();
                if (res.data) {
                    this.GetAllTransportationCompany();
                } else {
                    this.props.history.push('/error404')
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };

    GetAllTransportationCompany = () => {
        this.props.showSpinner();
        axios.get('/api/v1/transportation-companies/GetAll')
            .then((res) => {
                this.props.hideSpinner();
                if (res.data.data !== null) 
                {
                    this.setState({ AgentLists: res.data.data });
                   // console.log(res.data.data);
                }
               
                else
                this.setState({ alertText: res.data.errors, loginAlert: true, loading: false });
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };
    //loadProvinces = () => {
    //    this.props.showSpinner();
    //    axios.get('api/v1/provinces/GetAll')
    //        .then((res) => {
    //            this.props.hideSpinner();
    //            console.log(res.data);
    //            this.setState({ProvinceList: res.data.data});
    //        })
    //        .catch((error) => {
    //            this.props.hideSpinner();
    //            this.props.showAlert(showCatchError(error), "error");
    //            console.log(error.response);
    //        });
    //};

    OptionsMenuClick = (event, id) => {
        this.setState({ [id]: event.currentTarget, optionsMenu: id });
    };
    OptionsMenuClose = (id) => {
        this.setState({ [id]: null, optionsMenu: null });
    };
    openModal = (modalName,item) => {
        //if (modalName === "AddModal" || modalName === "EditModal") {
        //    if (this.state.ProvinceList.length === 0) {
        //        this.loadProvinces();
        //    }
        //}
           if (modalName === "ChangePassModal") {
            this.setState({
                [modalName]: true,
                UserName: "TC" + item.nationalId
            });
        }
        this.setState({[modalName]: true});
    }
    closeModal = (modalName) => {
        this.setState({ [modalName]: false });

        if (modalName !== "AgentChargeModal") {
            this.GetAllTransportationCompany();
        }
    };
    createMembershipForTransportationCompany = (Id) => {
        this.props.closeSweetAlert();
        this.props.showSpinner();
        axios.post('/api/v1/transportation-companies/CreateTransportationCompanyUser?TransportationCompanyId=' + Id)
            .then((res) => {
                if (res.data.data !== null) {
                    this.props.hideSpinner();
                    this.props.showAlert("حساب کاربری با موفقیت ساخته شد", "success");
                    this.setState({
                        newMemberUsername: res.data.data.userName,
                        newMemberPassword: res.data.data.password,
                        showNewMemberModal: true
                    });
                    this.GetAllTransportationCompany();
                }
                else {
                    this.props.hideSpinner();
                    this.props.showAlert(res.data.errors, 'error');
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            });
    };
    AcceptTransportationCompany = (id) => { 
        this.props.closeSweetAlert();
        this.props.showSpinner(); 
        axios.post('/api/v1/transportation-companies/AcceptTransportationCompany?TransportationCompanyId=' + id)
            .then((res) => {
                 
                    this.props.showAlert(res.data.message, 'success');
                    this.GetAllTransportationCompany();
                 
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };
     
    render() {
        return (
            <>
                <Row>
                    <Colxx xxs="12">
                        <h3>مدیریت شرکت های حمل و نقل</h3>
                        <Separator className="mb-5" />
                    </Colxx>
                </Row>

                <Row className="mb-3">
                    <Colxx xxs="12">
                        <Card>
                            <CardBody className="d-flex flex-column justify-content-center align-items-center">
                                <div className="d-flex justify-content-center w-100">
                                    <Button outline color="primary" className="mx-3"
                                            onClick={() => this.openModal("AddModal")}>
                                        افزودن شرکت حمل و نقل جدید
                                    </Button>
                                </div>

                                <Table
                                    tableHeaders={[
                                        "نام کامل",
                                        "آدرس",
                                        "کد ملی",
                                        "موبایل",
                                        "کد پستی",
                                        "وضعیت", 
                                        "ساختن",
                                        "تایید",
                                        ""
                                    ]}

                                    tableRow={this.state.AgentLists}

                                    tableData={[
                                        item => {
                                            return item.transportationCompanyName
                                        },
                                        item => {
                                            return item.address
                                        },
                                        item => {
                                            return item.nationalId;
                                        },
                                        item => {
                                            return item.mobile;
                                        },
                                        item => {
                                            return item.postalCode;
                                        },
                                        item => {
                                            return (
                                                item.transportationCompanyActive === false ?
                                                    <Badge color="outline-danger" pill>در انتظار تایید</Badge>
                                                    :
                                                    <Badge color="outline-success" pill>فعال</Badge>
                                            )
                                        },
                                        x => {
                                            if (x.isAccept === true) {

                                                return (
                                                    <Button outline color="success" size="sm"
                                                        onClick={() => this.props.showSweetAlert("آیا حساب کاربری برای این شرکت حمل و نقل کالا ساخته شود؟", "", "success", () => this.createMembershipForTransportationCompany(x.transportationCompanyId))}>
                                                        ساختن
                                                    </Button>
                                                )
                                            }
                                        },
                                        x => {
                                            return (
                                               
                                                  <Button outline color="primary" size="sm"
                                                    onClick={() => this.setState({ ShowFileUploadModal: true }, () => this.setState({ OneTransportationCompany: x })
                                                        )}>
                                                    تایید
                                                  </Button>

                                            )
                                        },
                                        item => {
                                            return (
                                                <>
                                                    <Button
                                                        outline color="primary" size="sm"
                                                        aria-controls={"menu-" + item.transportationCompanyId}
                                                        aria-haspopup="true"
                                                        aria-expanded={this.state.optionsMenu === item.transportationCompanyId ? 'true' : undefined}
                                                        onClick={(event) => this.OptionsMenuClick(event, item.transportationCompanyId)}
                                                    >
                                                       آيتم ها
                                                    </Button>
                                                    <Menu
                                                        id={"menu-" + item.transportationCompanyId}
                                                        MenuListProps={{'aria-labelledby': 'fade-button',}}
                                                        anchorEl={this.state[item.transportationCompanyId]}
                                                        open={this.state.optionsMenu === item.transportationCompanyId}
                                                        onClose={() => this.OptionsMenuClose(item.transportationCompanyId)}
                                                    >
                                                        <MenuItem onClick={() => this.setState({EditModal: true, OneTransportationCompany: item, optionsMenu: null})}>ویرایش</MenuItem>
                                                        <MenuItem onClick={() => this.setState({ ChangePassModal: true, UserName: "TC" + item.nationalId, optionsMenu: null })}>تغيير رمز كاربری</MenuItem>
                                                        <MenuItem onClick={() => this.setState({
                                                            ShowAccountActivityModal: true, 
                                                            transportationCompanyId: item.transportationCompanyId,
                                                            optionsMenu: null
                                                        })}>لیست تراکنش‌های مالی</MenuItem>
                                                        <MenuItem onClick={() => this.setState({ AgentChargeModal: true, OneTransportationCompany: item, optionsMenu: null })}>شارژ اعتبار</MenuItem>
                                                        {/* <MenuItem onClick={() => this.setState({kalaModal: true, transportationCompanyId: item.transportationCompanyId, optionsMenu: null})}>محموله‌های غیر مجاز</MenuItem>
                                                      
                                                        <MenuItem onClick={() => this.setState({AgentSazmanModal: true, transportationCompanyId: item.transportationCompanyId, optionsMenu: null})}>اطلاعات سازمانی</MenuItem>
                                                        <MenuItem onClick={() => this.setState({AgentAccessModal: true, transportationCompanyId: item.transportationCompanyId, optionsMenu: null})}>دسترسی‌ها</MenuItem>
                                                        <MenuItem onClick={() => this.props.history.push('/Members/' + item.transportationCompanyId)}>مدیریت کاربران</MenuItem>
                                                        <MenuItem onClick={() => this.setState({showFinancialConfigSalonModal: true, OneTransportationCompany: item, optionsMenu: null})}>تنظیمات مالی</MenuItem> */}
                                                    </Menu>
                                                </>
                                            )
                                        },
                                    ]}
                                />
                            </CardBody>
                        </Card>
                    </Colxx>
                </Row>

                <Modal isOpen={this.state.AddModal} size="xlg" toggle={() => this.closeModal("AddModal")}>
                    <ModalHeader toggle={() => this.closeModal("AddModal")}>
                        افزودن شرکت حمل و نقل جدید
                    </ModalHeader>
                    <ModalBody>
                        <NewTransportationCompany
                            isModal={true}
                           // ProvinceList={this.state.ProvinceList}
                            showSpinner={this.props.showSpinner}
                            hideSpinner={this.props.hideSpinner}
                            showSweetAlert={this.props.showSweetAlert}
                            closeSweetAlert={this.props.closeSweetAlert}
                            showAlert={this.props.showAlert}
                        />
                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.EditModal} size="xlg" toggle={() => this.setState({EditModal: false})}>
                    <ModalHeader toggle={() => this.setState({EditModal: false})}>
                        ویرایش شرکت حمل و نقل
                    </ModalHeader>
                    <ModalBody>
                        <EditTransportationCompany
                            OneTransportationCompany={this.state.OneTransportationCompany}
                          //  ProvinceList={this.state.ProvinceList}
                            showSpinner={this.props.showSpinner}
                            hideSpinner={this.props.hideSpinner}
                            showAlert={this.props.showAlert}
                            showSweetAlert={this.props.showSweetAlert}
                            closeSweetAlert={this.props.closeSweetAlert}
                            closeModal={this.closeModal}
                            isModal={true}
                        />
                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.kalaModal} size="xlg" toggle={() => this.setState({kalaModal: false})}>
                    <ModalHeader toggle={() => this.setState({kalaModal: false})}>
                        محموله‌های غیر مجاز
                    </ModalHeader>
                    <ModalBody>
                        <NotAllowedkalas
                            transportationCompanyId={this.state.transportationCompanyId}
                            showSpinner={this.props.showSpinner}
                            hideSpinner={this.props.hideSpinner}
                            showAlert={this.props.showAlert}
                            showSweetAlert={this.props.showSweetAlert}
                            closeSweetAlert={this.props.closeSweetAlert}
                        />
                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.ShowAccountActivityModal} toggle={() => this.setState({ShowAccountActivityModal: false})} size="xlg">
                    <ModalHeader toggle={() => this.setState({ShowAccountActivityModal: false})}>
                        لیست تراکنش‌های شرکت
                    </ModalHeader>
                    <ModalBody>
                        <PersonAccountActivities
                            id={this.state.transportationCompanyId}
                            role="TransportationCompany" 
                            showSpinner={this.props.showSpinner}
                            hideSpinner={this.props.hideSpinner}
                            showAlert={this.props.showAlert}
                        />
                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.AgentChargeModal} toggle={() => this.setState({AgentChargeModal: false})} size="xlg">
                    <ModalHeader toggle={() => this.setState({AgentChargeModal: false})}>
                        شارژ کیف پول شرکت حمل و نقل
                    </ModalHeader>
                    <ModalBody>
                        <ChargeTransportationCompany
                            TransportationCompany={this.state.OneTransportationCompany}
                            showSpinner={this.props.showSpinner}
                            hideSpinner={this.props.hideSpinner}
                            showAlert={this.props.showAlert}
                            showSweetAlert={this.props.showSweetAlert}
                            closeSweetAlert={this.props.closeSweetAlert}
                            closeModal={this.closeModal}
                        />
                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.AgentSazmanModal} toggle={() => this.setState({AgentSazmanModal: false})} size="xlg">
                    <ModalHeader toggle={() => this.setState({AgentSazmanModal: false})}>
                        اطلاعات سازمانی
                    </ModalHeader>
                    <ModalBody>
                        <AgentSazman
                            transportationCompanyId={this.state.transportationCompanyId}
                            showSpinner={this.props.showSpinner}
                            hideSpinner={this.props.hideSpinner}
                            showAlert={this.props.showAlert}
                            showSweetAlert={this.props.showSweetAlert}
                            closeSweetAlert={this.props.closeSweetAlert}
                            closeModal={this.closeModal}
                        />
                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.AgentAccessModal} toggle={() => this.setState({AgentAccessModal: false})} size="xlg">
                    <ModalHeader toggle={() => this.setState({AgentAccessModal: false})}>
                        دسترسی‌ها
                    </ModalHeader>
                    <ModalBody>
                        <AgentAccess
                            transportationCompanyId={this.state.transportationCompanyId}
                            showSpinner={this.props.showSpinner}
                            hideSpinner={this.props.hideSpinner}
                            showAlert={this.props.showAlert}
                        />
                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.showFinancialConfigSalonModal} toggle={() => this.setState({showFinancialConfigSalonModal: false})} size="xlg">
                    <ModalHeader toggle={() => this.setState({showFinancialConfigSalonModal: false})}>
                        تنظیمات مالی سالن
                    </ModalHeader>
                    <ModalBody>
                        <AgentSalonFinancialConfig
                            OneTransportationCompany={this.state.OneTransportationCompany}
                            showSpinner={this.props.showSpinner}
                            hideSpinner={this.props.hideSpinner}
                            showAlert={this.props.showAlert}
                            showSweetAlert={this.props.showSweetAlert}
                            closeSweetAlert={this.props.closeSweetAlert}
                            closeModal={this.closeModal}
                        />
                    </ModalBody>
                </Modal>
                <Modal isOpen={this.state.ChangePassModal} size="xlg" toggle={() => this.closeModal("ChangePassModal")}>
                    <ModalHeader toggle={() => this.closeModal("ChangePassModal")}>
                        تغییر رمز کاربری
                    </ModalHeader>
                    <ModalBody>
                        <ChangePassModal
                            UserName={this.state.UserName}
                            showSpinner={this.props.showSpinner}
                            hideSpinner={this.props.hideSpinner}
                            showAlert={this.props.showAlert}
                            closeModal={this.closeModal}
                        />
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={() => this.closeModal("ChangePassModal")}>
                            انصراف
                        </Button>
                    </ModalFooter>
                </Modal>
                
                <Modal isOpen={this.state.ShowFileUploadModal} toggle={() => this.setState({ ShowFileUploadModal: false, OneTransportationCompany: { }   })}>
                    <ModalHeader toggle={() => this.setState({ ShowFileUploadModal: false, OneTransportationCompany: {}    })}>
                        نمایش و تایید مدرک

                    </ModalHeader>
                    <ModalBody> 
                        <div className="d-flex mt-2 justify-content-center">
                            <h3>مدرک:</h3>
                            <p className="pl-4"> <a target="_blank"
                                href={Config.url + "TransportationCompanyUploadFile/" + toEnglishNumbers(this.state.OneTransportationCompany.fileName)}><img
                                    alt="" width="50px" height="50px"
                                    src={Config.url + "TransportationCompanyUploadFile/" + toEnglishNumbers(this.state.OneTransportationCompany.fileName)} /></a></p>
                        </div>
                        <div className="d-flex mt-2 justify-content-center">
                            <Button outline color="success" size="sm"
                                onClick={() => this.props.showSweetAlert("آیا از تایید این شركت حمل و نقل اطمینان دارید؟", "", "success", () => this.AcceptTransportationCompany(this.state.OneTransportationCompany.transportationCompanyId))}>
                                تایید
                            </Button>
                            
                        </div>
                    </ModalBody>
                </Modal>
                <Modal isOpen={this.state.showNewMemberModal} toggle={() => this.setState({ showNewMemberModal: false, newMemberUsername: null, newMemberPassword: null })}>
                    <ModalHeader toggle={() => this.setState({ showNewMemberModal: false, newMemberUsername: null, newMemberPassword: null })}>
                        اطلاعات کاربری
                    </ModalHeader>
                    <ModalBody>
                        <Alert color="danger">
                            توجه! لطفا اطلاعات کاربری زیر را
                            در اختیار مسئول مربوطه قرار دهید. بعد از بستن این
                            پنجره شما قادر به دیدن رمز عبور نخواهید بود.
                        </Alert>

                        <div>
                            <h3>نام کاربری:</h3>
                            <p className="pl-4">{this.state.newMemberUsername}</p>

                            <h3>رمز عبور:</h3>
                            <p className="pl-4">{this.state.newMemberPassword}</p>
                        </div>
                    </ModalBody>
                </Modal>

            </>
        );
    }
}

export default ManageTransportationCompany;